import { IPublicModelSettingField } from './';

/**
 * @deprecated please use IPublicModelSettingField
 */
export type IPublicModelSettingPropEntry  = IPublicModelSettingField
